import { useRouter } from 'next/router';

import { useIsWebview } from '../hooks/useIsWebview';

export const useWebviewThemeParameter = (): {
  theme: 'light' | 'dark' | undefined;
  isDarkTheme: boolean;
} => {
  const isWebview = useIsWebview();
  const router = useRouter();

  const themeParameter = typeof router.query.theme === 'string' ? router.query.theme : null;

  if (!themeParameter) {
    return {
      theme: isWebview ? 'light' : undefined,
      isDarkTheme: false,
    };
  }

  const theme = themeParameter === 'dark' ? 'dark' : 'light';

  return {
    theme,
    isDarkTheme: theme === 'dark',
  };
};
